<ng-container *ngComponentOutlet="currentStepComponent$ | async" />
